import { render, staticRenderFns } from "./FancyButton.vue?vue&type=template&id=77c664ca&scoped=true&"
import script from "./FancyButton.vue?vue&type=script&lang=js&"
export * from "./FancyButton.vue?vue&type=script&lang=js&"
import style0 from "./FancyButton.vue?vue&type=style&index=0&id=77c664ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c664ca",
  null
  
)

export default component.exports